const PREFIX = 'AppyBeeWidget:';

export const OLD_INTEGRATION_EVENT = {
    CLOSE: `${PREFIX}close`
}
